//#region src/assets.ts
/**
* The Sherpaw Vite plugin replaces this module with the selected models' asset imports.
* Hosts without the plugin expose no models, so shared UI can hide the Provider.
*/
const assets = Object.freeze({});
//#endregion
export { assets };
